(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scripts_head"] && !Shopify.designMode) return;
  try {
    jQuery.getJSON("https://api.ipify.org?format=json")
.done(function (data){
let country;
let ipAddress = data.ip;
jQuery.ajax({

async: true,

crossDomain: true,

dataType: "json",

url: "http://api.ipstack.com/" + ipAddress + "?access_key=52da5f3f66926a7039c90b786b4455dd&format=1",

success: function(data) {

country = data.country_code;

if (country === "CA")
{
window.location.href = "https://ca.bluedriver.com";
}

}

});
})
  } catch(e) { console.error(e); }
})();

})();
